import React, { useState, useEffect } from "react";
import { Paper, Grid } from "@material-ui/core";
import {
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
  InputCheckboxMaster,
} from "App/Component/ui";
import {
  RESET_STATE_MASTER_BARANG,
  STYLE_MASTER_BARANG,
  urlCreate,
  urlUpdate,
  validation,
  urlGetGolonganBarang,
  urlGetSatuan,
  urlGetProdusen,
  urlGetGolonganCoa,
} from ".";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  WMS_LGS_MS_BARANG,
  DEFAULT_VALUE_OPTION,
  TYPE_INSTANCE4,
  TYPE_INSTANCE5,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  changeHandlerLocalStorageForm,
  setLocalStorageAsFormData,
  removeLocalStorageAsFormData,
  convertToValidPrice,
  formatRupiah,
} from "App/utils/helpers";
import { useSelectOption } from "App/hooks";
import useSelectOptionCustom from "App/hooks/useSelectOptionCustom";
import { useMultipleSelect } from "hooks";
import { isNull } from "lodash";
import { validasiMultipleSelect } from "hooks/useMultipleSelect";

export const USER = localStorage.getItem("user_name");

export default function FormMasterGudang({
  formData,
  setFormData,
  barangId,
  setBarangId,
  setNewData,
}) {
  const classes = STYLE_MASTER_BARANG();
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  useEffect(() => {
    setLocalStorageAsFormData(setFormData, WMS_LGS_MS_BARANG);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const add = async () => {
    return instance4.post(urlCreate, {
      ...formData,
      user: USER,
      hargapokok:parseInt(convertToValidPrice(formData.hargapokok)),
      hargabeli:parseInt(convertToValidPrice(formData.hargabeli)),
      persediaan:parseInt(convertToValidPrice(formData.persediaan)),
      qjb:parseInt(convertToValidPrice(formData.qjb)),
      stockmax:parseInt(convertToValidPrice(formData.stockmax)),
      stockmin:parseInt(convertToValidPrice(formData.stockmin)),
    });
  };

  const update = () => {
    return instance4.post(urlUpdate, {
      ...formData,
      id: barangId,
      user: USER,
      hargapokok:parseInt(convertToValidPrice(formData.hargapokok)),
      hargabeli:parseInt(convertToValidPrice(formData.hargabeli)),
      persediaan:parseInt(convertToValidPrice(formData.persediaan)),
      qjb:parseInt(convertToValidPrice(formData.qjb)),
      stockmax:parseInt(convertToValidPrice(formData.stockmax)),
      stockmin:parseInt(convertToValidPrice(formData.stockmin)),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    // const validation

    const valid = validation(formData);
    if (valid.state) {
      try {
        if (barangId === "") {
          const res = await add();
          if (res.data.status === 200) {
            remove();
            defaultToastSuccess("Berhasil menambah barang");
            setNewData();
          } else {
            defaultToastError(res?.data?.message);
          }
        } else if (barangId !== "") {
          const res = await update();
          if (res.data.status === 200) {
            remove();
            defaultToastSuccess("Berhasil mengubah barang");
            setNewData();
          } else {
            defaultToastError(res?.data?.message);
          }
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      defaultToastError(valid.message);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    }
  };

  const remove = () => {
    removeLocalStorageAsFormData(WMS_LGS_MS_BARANG);
    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    setFormData(RESET_STATE_MASTER_BARANG);
  };

  const handleChange = (text) => (e) => {
    changeHandlerLocalStorageForm(
      text,
      e,
      formData,
      setFormData,
      WMS_LGS_MS_BARANG
    );
  };

  const handleChangeNumber = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: formatRupiah(e.target.value),
    });
  };

  const produsen = useSelectOption(true, urlGetProdusen, TYPE_INSTANCE4);

  const multipleSelectData = useMultipleSelect([
    {
      url: urlGetGolonganBarang,
      search: true,
      type_instance: TYPE_INSTANCE4,
      value: "id",
      label: ["name"],
      type_response: "data",
      key: "name",
      attr_addition: ["golcoa_id", "golcoa_code", "golcoa_name"],
      attr_addition_value: ["coa_id", "coa_code", "coa_name"],
    },
  ]);

  const golonganCoa = useSelectOptionCustom(
    true,
    urlGetGolonganCoa,
    TYPE_INSTANCE5,
    "id",
    "name",
    "code",
    "body",
    { headers: { level: 4 } }
  );

  const satuan = useSelectOption(true, urlGetSatuan, TYPE_INSTANCE4);
  const changeSelectCoa = (e, name_id, name_label, code) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
      [code]: e?.code,
    });
  };

  const changeSelect = (e, name_id, name_label, code) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
    });
  };

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              name="id"
              label="ID"
              id="id"
              value={formData.id}
              placeholder="ID"
              disabled={true}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="kode_produk"
              label="KODE PRODUK"
              id="kode_produk"
              value={formData.kode_produk}
              onChange={handleChange("kode_produk")}
              placeholder="Kode Produk"
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="name"
              label="NAMA BARANG"
              id="name"
              value={formData.name}
              onChange={handleChange("name")}
              placeholder="Nama Barang"
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="barcode"
              label="BARCODE"
              id="barcode"
              value={formData.barcode}
              onChange={handleChange("barcode")}
              placeholder="Barcode"
            />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputOptionMaster
              name="produsen_id"
              label="PRODUSEN"
              id="produsen_id"
              withSearch={true}
              labelValue={formData?.produsen_name}
              data={
                produsen?.length > 0
                  ? produsen
                  : [DEFAULT_VALUE_OPTION("Produsen")]
              }
              value={formData.produsen_id}
              onChange={(e) => changeSelect(e, "produsen_id", "produsen_name")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="golongan_id"
              label="GOLONGAN BARANG"
              id="golongan_id"
              withSearch={true}
              labelValue={formData?.golongan_name}
              data={validasiMultipleSelect(multipleSelectData, 0)}
              value={formData.golongan_id}
              onChange={(e) => {
                isNull(e)
                  ? setFormData({
                      ...formData,
                      golongan_id: "",
                      golongan_name: "Pilih Golongan Barang",
                      golcoa_id: "",
                      golcoa_code: "",
                      golcoa_name: "Pilih Golongan COA",
                    })
                  : setFormData({
                      ...formData,
                      golongan_id: e?.value,
                      golongan_name: e?.label,
                      golcoa_id: e?.golcoa_id,
                      golcoa_code: e?.golcoa_code,
                      golcoa_name: e?.golcoa_name,
                    });
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              type="text"
              name="harga_pokok"
              label="HARGA POKOK"
              id="harga_pokok"
              disabled={formData.akses ? false : true}
              placeholder="Harga Pokok"
              onChange={handleChangeNumber("hargapokok")}
              value={formData.hargapokok}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              type="text"
              name="harga_beli"
              label="Harga Beli"
              id="harga_beli"
              disabled={formData.akses ? false : true}
              placeholder="Harga Beli"
              onChange={handleChangeNumber("hargabeli")}
              value={formData.hargabeli}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              type="text"
              name="persediaan"
              label="PERSEDIAAN"
              id="persediaan"
              disabled={formData.akses ? false : true}
              placeholder="Persediaan"
              onChange={handleChangeNumber("persediaan")}
              value={formData.persediaan}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              type="text"
              name="stockmin"
              label="STOCK MIN"
              id="stockmin"
              placeholder="Stock Min"
              value={formData.stockmin}
              onChange={handleChangeNumber("stockmin")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              type="text"
              name="stockmax"
              label="STOCK MAX"
              id="stockmax"
              placeholder="Stock Max"
              value={formData.stockmax}
              onChange={handleChangeNumber("stockmax")}
            />
          </Grid>
          {/* <Grid item sm={3}>
            <InputTextMaster
              type="number"
              name="nilaikritis"
              label="STOK KRITIS"
              id="nilaikritis"
              placeholder="Stock Kritis"
              value={formData.nilaikritis}
              onChange={handleChange("nilaikritis")}
            />
          </Grid> */}
          <Grid item sm={3}>
            <InputOptionMaster
              name="golcoa_id"
              label="Golongan Coa"
              labelValue={formData?.golcoa_name}
              id="golcoa_id"
              withSearch={true}
              value={formData.golcoa_id}
              disabled={true}
              code={formData.golcoa_code}
              data={
                golonganCoa?.length > 0
                  ? golonganCoa
                  : [DEFAULT_VALUE_OPTION("Golongan COA")]
              }
              onChange={(e) =>
                changeSelectCoa(e, "golcoa_id", "golcoa_name", "golcoa_code")
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputOptionMaster
              name="satuanbeli_id"
              label="SATUAN BELI"
              id="satuanbeli_id"
              withSearch={true}
              labelValue={formData?.satuanbeli_name}
              data={
                satuan?.length > 0 ? satuan : [DEFAULT_VALUE_OPTION("Satuan")]
              }
              value={formData.satuanbeli_id}
              onChange={(e) =>
                changeSelect(e, "satuanbeli_id", "satuanbeli_name")
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="satuanjual_id"
              label="SATUAN PAKAI"
              id="satuanjual_id"
              withSearch={true}
              labelValue={formData?.satuanjual_name}
              data={
                satuan?.length > 0 ? satuan : [DEFAULT_VALUE_OPTION("Satuan")]
              }
              value={formData.satuanjual_id}
              onChange={(e) =>
                changeSelect(e, "satuanjual_id", "satuanjual_name")
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              type="text"
              name="qjb"
              label="QJB"
              id="qjb"
              value={formData.qjb}
              onChange={handleChangeNumber("qjb")}
              placeholder="Qjb"
            />
          </Grid>
          <Grid item sm={2}>
            <div
              style={{
                marginTop: "1.5rem",
              }}
            >
              <InputCheckboxMaster
                checked={formData.is_active}
                name="is_active"
                id="is_active"
                label="Aktif"
                onChange={() =>
                  setFormData({ ...formData, is_active: !formData.is_active })
                }
              />
            </div>
          </Grid>
        </Grid>

        <div className="mt-2">
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MasterButton
              outline={true}
              type={"button"}
              onClick={() => {
                removeLocalStorageAsFormData(WMS_LGS_MS_BARANG);
                setFormData(RESET_STATE_MASTER_BARANG);
              }}
              color="danger"
              name="Reset"
              size="md"
            />
            <MasterButton
              outline={false}
              type={"submit"}
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.disabled}
              size="md"
            />
          </Grid>
        </div>
      </form>
    </Paper>
  );
}
